<template>

  <div class="panel panel-clinic">

    <div class="panel-heading collapsed" href="#form_connection_pt" data-toggle="collapse">

      <div class="arrow-down"></div>

      <h2 class="panel-title">Anslutning PT</h2>

    </div>

    <div id="form_connection_pt" class="panel-collapse collapse">

      <div class="panel-body">

        <div class="form-horizontal">
          <div class="form-group oddevencol">
            <label class="col-md-14 control-label">Skickat välkomstmail (via systemet)</label>
            <div class="col-md-36">
              <p>{{ clinic.contract_pt_sent }}</p>
            </div>
          </div>
          <div class="form-group oddevencol">
            <label class="col-md-14 control-label">Skickat demokort (via systemet)</label>
            <div class="col-md-36">
              <p>{{ clinic.demo_card_sent }}</p>
            </div>
          </div>
          <row-meta
            :clinic-id="clinic.id"
            :row-meta="meta"
            :showForced="true"
            :showDate="true"
            :showComment="true"
            type="checkbox_letter_sent_pt"
            layout="checkBox"
            title="Skickat startkit">
          </row-meta>
        </div>

        <div class="form-horizontal">
          <row-meta
            :clinic-id="clinic.id"
            :row-meta="meta"
            :showForced="true"
            :showDate="true"
            :showComment="true"
            type="checkbox_booking_pt"
            layout="checkBox"
            title="Bokningsförfarande ok"
            comment="Är våra tjänster upplagda i nätbaserad kalender? Eller finns annat bokningsförfarande definierat för våra kunder?">
          </row-meta>
        </div>

        <div class="form-horizontal">

          <div class="row row-meta oddevencol validateRule approvedIntExt"
               v-bind:class="{ complete: validateRule('rule_reconciliation_pt') }">
            <div class="col-md-50 control-label first withcomm">
              <label style="font-weight:normal;">Godkänd avstämning med PT</label>
            </div>
          </div>

          <row-meta
            :clinic-id="clinic.id"
            :row-meta="meta"
            :showForced="true"
            :showDate="true"
            :showComment="true"
            type="checkbox_reconciliation_payment_account_pt"
            layout="checkBox"
            title="Har PT lagt in sina bankuppgifter?">
          </row-meta>

          <row-meta
            :clinic-id="clinic.id"
            :row-meta="meta"
            :showForced="true"
            :showDate="true"
            :showComment="true"
            type="checkbox_reconciliation_signature_pt"
            layout="checkBox"
            title="Har PT provat sin signatur i demokortet?">
          </row-meta>

          <row-meta
            :clinic-id="clinic.id"
            :row-meta="meta"
            :showForced="true"
            :showDate="true"
            :showComment="true"
            type="checkbox_reconciliation_recover_card_pt"
            layout="checkBox"
            title='Har ni gått igenom de viktigaste delarna i avtalet samt bilagan?'>
          </row-meta>

          <row-meta
            :clinic-id="clinic.id"
            :row-meta="meta"
            :showForced="true"
            :showDate="true"
            :showComment="true"
            type="checkbox_reconciliation_deviation_pt"
            layout="checkBox"
            title="Vet PT hur hen ska skicka in en manuell registrering?">
          </row-meta>
        </div>

        <div class="form-horizontal">

          <div class="row row-meta oddevencol validateRule approvedIntExt"
               v-bind:class="{ complete: clinic.is_public }">
            <div class="col-md-50 control-label first withcomm">
              <label style="font-weight:normal;">Publicerad i klippkort</label>
            </div>
          </div>

        </div>

      </div>

    </div>

  </div>

</template>

<script>

import mixin from './mixin'

export default {

    mixins: [mixin],

    data () {
        return {}
    },

    computed: {

    },

    methods: {

    }

}

</script>
